import React from 'react'
import { exportToCSV, exportToExcel } from '../../ExportUtils';
import { FaFileCsv, FaFileExcel } from "react-icons/fa";
const DataTableHeader = ({ columns, data }) => {
  const getDynamicFilename = (columns) => {

    const currentDate = new Date().toISOString().slice(0, 10);
    const randomNumber = Math.floor(1000 + Math.random() * 9000);
    return `Data_Export_${currentDate}_${randomNumber}`;
  };

  return (
    <div className="d-flex flex-wrap justify-content-end align-items-center gap-2 mb-3 data-table-export">
      <button
        className="btn btn-outline-secondary btn-sm d-inline-flex align-items-center gap-2"
        onClick={() => exportToCSV(columns, data, getDynamicFilename(columns))}
      >
        <FaFileCsv /> CSV
      </button>

      <button
        className="btn btn-success btn-sm d-inline-flex align-items-center gap-2"
        onClick={() => exportToExcel(columns, data, getDynamicFilename(columns))}
      >
        <FaFileExcel /> Excel
      </button>
    </div>
  )
}

export default DataTableHeader
